import { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DateTime, Interval } from 'luxon';
import Step from './Step';
import PayConfirmModal from '../PayConfirmModal';
import { useTypedSelector } from 'src/hooks/useTypeSelector';
import { dineroSubtractPrice } from 'src/common/utils/dataFormat';
import { IOrderForClient } from 'src/models/IOrder';
import './styles.scss';
import './media.scss';

interface IProps {
  order: IOrderForClient;
}

const Steps: FC<IProps> = ({ order }) => {
  const navigate = useNavigate();
  const { client, isLoading } = useTypedSelector(state => state.client);
  const {
    id,
    status,
    licenseHash,
    additional_driver,
    inviteDriverHash,
    start_date,
    pdf_order,
    signRaHash,
    price,
    partial_paid,
    currency
  } = order;
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className='steps'>
        <h3>Take Next Steps for Check-in</h3>
        <div className='steps__container'>
          <Step
            title='Upload Docs'
            status={
              !!client!.driver_license?.insurance && client!.driver_license?.photos?.length === 2
                ? 'completed'
                : 'complete'
            }
            statusText={
              !!client!.driver_license?.insurance && client!.driver_license?.photos?.length === 2
                ? 'completed'
                : 'complete now'
            }
            handleClick={
              !!client!.driver_license?.insurance && client!.driver_license?.photos?.length === 2
                ? () => {}
                : () => navigate(`/license/${licenseHash}`)
            }
          />
          <Step
            title='Invite Drivers'
            status={additional_driver.length ? 'completed' : 'complete'}
            statusText={additional_driver.length ? 'invite more' : 'invite now'}
            handleClick={() => navigate(`/driver/add/${inviteDriverHash}`)}
          />
          <Step
            title='Payment'
            status={
              !client!.driver_license?.insurance &&
              (!client!.driver_license?.photos || client!.driver_license?.photos.length < 2)
                ? 'closed'
                : status === 'paid'
                ? 'completed'
                : 'complete'
            }
            statusText={
              !client!.driver_license?.insurance &&
              (!client!.driver_license?.photos || client!.driver_license?.photos.length < 2)
                ? 'available later'
                : status === 'paid'
                ? 'completed'
                : 'pay now'
            }
            handleClick={
              isLoading.pay ||
              status === 'paid' ||
              (!client!.driver_license?.insurance &&
                (!client!.driver_license?.photos || client!.driver_license?.photos.length < 2))
                ? () => {}
                : () => setOpen(true)
            }
          />
          <Step
            title='E-sign'
            status={
              Interval.fromDateTimes(DateTime.now(), DateTime.fromISO(start_date)).toDuration([
                'days'
              ]).days > 2 || status !== 'paid'
                ? 'closed'
                : pdf_order
                ? 'completed'
                : 'complete'
            }
            statusText={
              Interval.fromDateTimes(DateTime.now(), DateTime.fromISO(start_date)).toDuration([
                'days'
              ]).days > 2
                ? 'available later'
                : pdf_order
                ? 'completed'
                : 'complete now'
            }
            handleClick={
              Interval.fromDateTimes(DateTime.now(), DateTime.fromISO(start_date)).toDuration([
                'days'
              ]).days > 2 ||
              pdf_order ||
              status !== 'paid'
                ? () => {}
                : () => navigate(`/contract/${signRaHash}`)
            }
          />
          <Step
            title='Pickup info & keys'
            status={
              Interval.fromDateTimes(DateTime.now(), DateTime.fromISO(start_date)).toDuration([
                'days'
              ]).days > 2 || !pdf_order
                ? 'closed'
                : 'completed'
            }
            statusText={
              Interval.fromDateTimes(DateTime.now(), DateTime.fromISO(start_date)).toDuration([
                'days'
              ]).days > 2 || !pdf_order
                ? 'available later'
                : 'completed'
            }
            handleClick={() => {}}
          />
        </div>
      </div>
      <PayConfirmModal
        orderId={id}
        price={dineroSubtractPrice(price, partial_paid, currency)}
        startDate={start_date}
        card={client!.card}
        open={open}
        handleClose={() => setOpen(false)}
      />
    </>
  );
};

export default Steps;
